import rightContainer from "../../../../assets/images/Container.png";

const Hero = () => {
  return (
    <section className="background-secondary px-lg-5 px-md-4 px-sm-3 px-0">
      <div className="max-width-custom pb-0">
        <div className="row align-items-center pt-4">
          {/* Left Part */}
          <div className="col-lg-6 col-md-6 col-12 px-4 mt-2 mt-md-0">
            <div className="hero-left pb-3">
              <p>Because When Life’s Organized, Anything Is Possible</p>
            </div>
            <div className="pt-lg-5 pt-md-4 pt-sm-3 pt-2 hero-para-left">
              <p className="fs-5">
                Keeping Your Most Important Essentials Organized, Accessible,
                and Right Where You Need Them—Anytime, Anywhere.
              </p>
            </div>
          </div>

          {/* Right Part */}
          <div className="col-lg-6 col-md-6 col-12 text-center">
            <img
              src={rightContainer}
              alt="download-img"
              className="hero-img-right img-fluid"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
